import { resolveComponent as _resolveComponent, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-38ecb662")

_pushScopeId("data-v-38ecb662")
const _hoisted_1 = { class: "query-input" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_input, _mergeProps({ id: _ctx.inputId }, _ctx.$attrs, {
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _ctx.modelValueChange,
      class: { empty: _ctx.isEmpty },
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('enterKeyUp')), ["enter"])),
      size: "small"
    }), null, 16, ["id", "modelValue", "onUpdate:modelValue", "class"]),
    _createVNode("label", { for: _ctx.inputId }, _toDisplayString(_ctx.labelName), 9, ["for"])
  ]))
})